import React, { useState, useEffect } from 'react';
import { db } from '../firebaseConfig/firebase';
import { collection, addDoc, query, where, getDocs, onSnapshot, deleteDoc, doc, orderBy } from "firebase/firestore";
import { Form, Button, Alert, Container, Spinner, Table, Card } from 'react-bootstrap';
import Header from './Header';

function AddTribunalMember() {
    const [email, setEmail] = useState('');
    const [members, setMembers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [fetching, setFetching] = useState(true);
    const [status, setStatus] = useState({ type: '', msg: '' });

    // 1. Escuchar cambios en la colección en tiempo real
    useEffect(() => {
        const q = query(collection(db, "tribu-equipo"), orderBy("EMAIL", "asc"));
        
        const unsubscribe = onSnapshot(q, (snapshot) => {
            const docs = [];
            snapshot.forEach((doc) => {
                docs.push({ id: doc.id, ...doc.data() });
            });
            setMembers(docs);
            setFetching(false);
        }, (error) => {
            console.error("Error al obtener miembros:", error);
            setFetching(false);
        });

        return () => unsubscribe();
    }, []);

    const handleAddMember = async (e) => {
        e.preventDefault();
        const cleanEmail = email.trim().toLowerCase();
        if (!cleanEmail) return;

        setLoading(true);
        setStatus({ type: '', msg: '' });

        try {
            const memberRef = collection(db, "tribu-equipo");
            const q = query(memberRef, where("EMAIL", "==", cleanEmail));
            const querySnapshot = await getDocs(q);

            if (!querySnapshot.empty) {
                setStatus({ type: 'warning', msg: 'Este usuario ya es miembro.' });
                setLoading(false);
                return;
            }

            await addDoc(memberRef, {
                EMAIL: cleanEmail,
                FECHA_ALTA: new Date().toLocaleDateString(),
                ROL: 'tribunal'
            });

            setStatus({ type: 'success', msg: 'Miembro añadido.' });
            setEmail('');
        } catch (error) {
            setStatus({ type: 'danger', msg: 'Error al guardar.' });
        } finally {
            setLoading(false);
        }
    };

    const deleteMember = async (id) => {
        if (window.confirm("¿Estás seguro de que quieres eliminar a este miembro?")) {
            try {
                await deleteDoc(doc(db, "tribu-equipo", id));
            } catch (error) {
                console.error("Error al eliminar:", error);
            }
        }
    };

    return (
        <>
            <Header />
            <Container className="mt-4 mb-5">
                <Card className="shadow-sm mb-4">
                    <Card.Body>
                        <h5 className="mb-3">Gestionar Equipo Tribunal</h5>
                        <Form onSubmit={handleAddMember} className="d-flex gap-2">
                            <Form.Control
                                type="email"
                                placeholder="Correo del nuevo miembro"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                disabled={loading}
                            />
                            <Button variant="primary" type="submit" disabled={loading || !email}>
                                {loading ? <Spinner animation="border" size="sm" /> : 'Añadir'}
                            </Button>
                        </Form>
                        {status.msg && <Alert variant={status.type} className="mt-3 py-2 small" dismissible>{status.msg}</Alert>}
                    </Card.Body>
                </Card>

                <Card className="shadow-sm">
                    <Card.Header className="bg-white">
                        <h6 className="mb-0">Miembros Actuales ({members.length})</h6>
                    </Card.Header>
                    <Card.Body className="p-0">
                        {fetching ? (
                            <div className="text-center p-4"><Spinner animation="border" variant="secondary" /></div>
                        ) : (
                            <Table responsive hover className="mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th>Email</th>
                                        <th>Fecha Alta</th>
                                        <th className="text-end">Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {members.length > 0 ? members.map((m) => (
                                        <tr key={m.id}>
                                            <td className="align-middle">{m.EMAIL}</td>
                                            <td className="align-middle text-muted small">{m.FECHA_ALTA}</td>
                                            <td className="text-end">
                                                <Button 
                                                    variant="outline-danger" 
                                                    size="sm" 
                                                    onClick={() => deleteMember(m.id)}
                                                >
                                                    Eliminar
                                                </Button>
                                            </td>
                                        </tr>
                                    )) : (
                                        <tr><td colSpan="3" className="text-center text-muted p-4">No hay miembros registrados.</td></tr>
                                    )}
                                </tbody>
                            </Table>
                        )}
                    </Card.Body>
                </Card>
            </Container>
        </>
    );
}

export default AddTribunalMember;